import { DaoModel } from '@dynameat/models';

export class ProductBoost extends DaoModel {
  constructor(guid, startDate, endDate, price, isRankBoosted, isSpecialBoosted, productGuid, services) {
    super(guid);
    this.startDate = startDate || new Date();
    this.endDate = endDate || new Date();
    this.price = price || null;
    this.isRankBoosted = isRankBoosted || false;
    this.isSpecialBoosted = isSpecialBoosted || false;
    this.productGuid = productGuid || null;
    this.services = services || [];
  }

  static toInstance(props = {}) {
    return new ProductBoost(
      props.guid,
      new Date(props.start_date),
      new Date(props.end_date),
      props.price,
      props.is_rank_boosted,
      props.is_special_boosted,
      props.product,
      props.services,
    );
  }

  serialize() {
    return {
      start_date: this.formatDate(this.startDate),
      end_date: this.formatDate(this.endDate),
      price: this.price,
      is_rank_boosted: this.isRankBoosted,
      is_special_boosted: this.isSpecialBoosted,
      product: this.productGuid,
      services: this.services,
    };
  }

  canBeApplied(startDate, endDate) {
    return endDate >= this.startDate && startDate <= this.endDate;
  }

  formatDate(date) {
    let month = `${date.getMonth() + 1}`;
    let day = `${date.getDate()}`;
    const year = date.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return [year, month, day].join('-');
  }
}
